"use strict";
/**
 * Sizes of the workflow cards in world pixels. The edgeless document, the
 * layout and the editor's canvas read them, so the server places steps the
 * same way the editor draws them.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKFLOW_LOOP_HEAD_HEIGHT = exports.WORKFLOW_STEP_WIDTH = void 0;
/** Width of a step card on the canvas: the width of a step block. */
exports.WORKFLOW_STEP_WIDTH = 312;
/** Height of the pill a loop wears on the edge of its frame. */
exports.WORKFLOW_LOOP_HEAD_HEIGHT = 26;
